import { css } from 'styled-components';

export const errorMessage = css`
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const formSectionLegendWrapper = css`
  padding: 0.75rem 0 0.5rem;
`;

export const formSectionFieldset = css`
  &::after,
  &::before {
    clear: both;
    content: '';
    display: table;
  }
`;

export const legendTitle = css`
  border-bottom: 1px solid #d9dbdc;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 0;
  padding-bottom: 0.5rem;
  width: 100%;

  ${({ theme }) =>
    theme.formSectionInvalid &&
    css`
      border-bottom: 2px solid #e96666;
    `}
`;

export const legendSubtitle = css`
  font-size: 13px;
  line-height: 19px;
  display: block;
  margin-bottom: 0;
  padding-top: 0.5rem;
`;

export const formSectionWrapper = css`
  & + & {
    margin-top: 2.5rem;
  }
`;
